module.exports = __webpack_public_path__ + "static/media/back_left_arrow.6468634d.svg";